import { VehiclePowertrain, VehicleTag } from '@/types';

// フィルターオプション
export const VEHICLE_TYPE_OPTIONS = [
  { value: 'KEI', label: '軽自動車' },
  { value: 'FUTSU', label: '普通車' },
  { value: 'KOGATA', label: '小型車' },
  { value: 'CHUUGATA', label: '中型車' },
  { value: 'OOGATA', label: '大型車' },
  { value: 'KYODAI', label: '巨大車' },
];

export const POWERTRAIN_OPTIONS = [
  { value: VehiclePowertrain.GASOLINE, label: 'ガソリン' },
  { value: VehiclePowertrain.DIESEL, label: 'ディーゼル' },
  { value: VehiclePowertrain.HYBRID, label: 'ハイブリッド' },
  { value: VehiclePowertrain.SERIES_HYBRID, label: 'シリーズHV' },
  { value: VehiclePowertrain.MILD_HYBRID, label: 'マイルドHV' },
  { value: VehiclePowertrain.PLUGIN_HYBRID, label: 'プラグインHV' },
  { value: VehiclePowertrain.ELECTRIC, label: '電気' },
];

export const VEHICLE_TAG_OPTIONS = [
  { value: VehicleTag.IMMOBILIZED, label: '不動車' },
  { value: VehicleTag.LOW_HEIGHT, label: '低車高' },
  { value: VehicleTag.WIDE_BODY, label: 'ワイド' },
  { value: VehicleTag.WELFARE, label: '福祉車両' },
  { value: VehicleTag.CAMPING, label: 'キャンピング' },
  { value: VehicleTag.CLASSIC, label: '旧車' },
];

export const ACTIVE_STATUS_OPTIONS = [
  { value: 'all', label: '全て' },
  { value: 'active', label: '稼働中' },
  { value: 'inactive', label: '停止中' },
];

// テーブルヘッダー
export const TABLE_HEADERS = {
  VEHICLE_TYPE: '車種タイプ',
  MANUFACTURER: 'メーカー',
  MODEL: 'モデル',
  POWERTRAIN: 'パワートレイン',
  TAGS: 'タグ',
  SPECIFICATIONS: '仕様',
  DATA_SOURCE: 'データソース',
  CASE_COUNT: '使用案件数',
  ACTIVE_STATUS: '稼働状態',
};

// フォームラベル
export const FORM_LABELS = {
  SEARCH_PLACEHOLDER: '車両モデル名で検索...',
  MANUFACTURER_FILTER: 'メーカー',
  VEHICLE_TYPE_FILTER: '車種タイプ',
  POWERTRAIN_FILTER: 'パワートレイン',
  TAGS_FILTER: 'タグ',
  ACTIVE_STATUS_FILTER: '稼働状態',
  RESET_FILTERS: 'フィルターリセット',
};

// ボタンテキスト
export const BUTTON_TEXTS = {
  RESET_FILTERS: 'フィルターリセット',
  NEW_VEHICLE_MODEL: '新規車両モデル',
  VIEW_DETAILS: '詳細表示',
};

// メッセージ
export const MESSAGES = {
  NO_RESULTS: '検索条件に一致する車両モデルがありません',
  RESULTS_COUNT: (count: number) => `${count}件の車両モデル`,
  LOADING: '読み込み中...',
  DELETE_CONFIRM: '本当にこの車両モデルを削除しますか？',
  DELETE_ERROR_IN_USE: 'この車両モデルは案件で使用中のため削除できません。',
};

// データソースラベル
export const DATA_SOURCE_LABELS = {
  RAKUHAI_PROVIDED: 'ラクハイ提供',
  CUSTOM: '独自登録',
};

// 設定値
export const SEARCH_DEBOUNCE_DELAY = 300;
export const ITEMS_PER_PAGE = 50;

// レスポンシブブレークポイント
export const RESPONSIVE_BREAKPOINTS = {
  MOBILE_MAX: 'lg:hidden',
  DESKTOP_MIN: 'hidden lg:block',
};
